//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import pick from 'lodash.pick';
import { addDictItem, editDictItem } from '@/api/api';
export default {
  name: "DictItemModal",
  data: function data() {
    return {
      title: "操作",
      visible: false,
      visibleCheck: true,
      model: {},
      dictId: "",
      status: 1,
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        itemText: {
          rules: [{
            required: true,
            message: '请输入名称!'
          }]
        },
        itemValue: {
          rules: [{
            required: true,
            message: '请输入数据值!'
          }]
        }
      }
    };
  },
  created: function created() {},
  methods: {
    add: function add(dictId) {
      this.dictId = dictId;
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      if (record.id) {
        this.dictId = record.dictId;
        this.visibleCheck = record.status == 1 ? true : false;
      }

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.model.dictId = this.dictId;
      this.model.status = this.status;
      this.visible = true;
      this.$nextTick(function () {
        _this.form.setFieldsValue(pick(_this.model, 'itemText', 'itemValue', 'description', 'sortOrder'));
      });
    },
    onChose: function onChose(checked) {
      if (checked) {
        this.status = 1;
        this.visibleCheck = true;
      } else {
        this.status = 0;
        this.visibleCheck = false;
      }
    },
    // 确定
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          values.itemText = (values.itemText || '').trim();
          values.itemValue = (values.itemValue || '').trim();
          values.description = (values.description || '').trim();
          var formData = Object.assign(_this2.model, values);
          formData.status = _this2.status;
          var obj;

          if (!_this2.model.id) {
            obj = addDictItem(formData);
          } else {
            obj = editDictItem(formData);
          }

          obj.then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    // 关闭
    handleCancel: function handleCancel() {
      this.close();
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    }
  }
};